import { render, staticRenderFns } from "./NbPassInput.vue?vue&type=template&id=0237daf2&scoped=true&"
import script from "./NbPassInput.vue?vue&type=script&lang=js&"
export * from "./NbPassInput.vue?vue&type=script&lang=js&"
import style0 from "./NbPassInput.vue?vue&type=style&index=0&id=0237daf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237daf2",
  null
  
)

export default component.exports